export const NO_TEAM = 'NO_AVAILABLE_TEAM'

export const defaultScenarioTab = () =>
  sessionStorage.getItem('lastScenarioTab') || 'custom'
